import React, {useEffect, useState} from "react";
import "../App.css";
import { Helmet } from "react-helmet";
import axios from "axios";

import { ColorModeIcon } from "../context/ColorModeContext.tsx";

import Navbar from "../components/Navbar.tsx";
import CustomTextField from "../components/CustomTextField.tsx";
import CustomSelect from "../components/CustomSelect.tsx";
import {SelectChangeEvent} from "@mui/material/Select";

import "../CSS/programmes/OnOffArticle.css";

import { SubmitButton } from "../components/Buttons.tsx";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import SearchableMultiSelect from "../components/SearchableMultiSelect.tsx";

interface MarketData {
  [key: string]: string; // assuming the values are strings, change it if needed
}

function OnOffArticle() {
  const backendUrl = import.meta.env.VITE_REACT_APP_BACKEND_URL;

  // States for mandatory information
  const [prodID, setProdID] = useState<string>("");
  const [selectedCheckbox, setSelectedCheckbox] = useState<string | null>(null);

  // State for the different online selections:
  const [selectedLieferzeit, setSelectedLieferzeit] = useState("1");
  const [selectedMarkierung2, setSelectedMarkierung2] = useState("8");
  const [selectedLager, setSelectedLager] = useState(
    "Kommissionslager Bestellartikel"
  );
  const [markets, setMarkets] = useState<{ value: string | number; label: string }[]>([]);
  const [selectedMarkets, setSelectedMarkets] = useState<{ value: string | number; label: string }[]>([]);

  const [infoMessage, setinfoMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {

    const fetchData = async () => {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        const response = await axios.get<MarketData>(`${backendUrl}/general/get_markets/`, config)
        const formattedData = Object.entries(response.data).map(([label, value]) => (
          {label: label, value: value}));
        setMarkets(formattedData);
      } catch (error) {
        setErrorMessage("Fehler beim laden der Märkte. Bitte lade die Seite erneut oder wende dich an Jonathan.");
      }
    };

    fetchData();

  }, []);

  // Handler for User Input;
  const handleItemIDChange = (element: React.ChangeEvent<HTMLInputElement>) => {
    setProdID(element.target.value);
    // console.log("Product ID:", prodID);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = event.target;
    setSelectedCheckbox(name);
    console.log(name);
  };

  const handleGoButton = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    setinfoMessage(null);
    if (prodID === "") {
      const err = "Bitte gebe eine Item ID ein";
      setErrorMessage(err);
      alert(err);
    } else if (selectedCheckbox === "checkboxOnline") {
      setErrorMessage(null);

      const marketIds = selectedMarkets.map((market) => market.value);
      const data = {
        item_id: prodID,
        availability: selectedLieferzeit,
        flag_2: selectedMarkierung2,
        lager: selectedLager,
        market_ids: marketIds
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      await axios
        .put(
          `${backendUrl}/OnlineOffline_Artikel/online/`,
          data,
          config
        )
        .then((res) => {
          setinfoMessage(res.data);
          // Handle successful response
          // alert(res.data);
        })
        .catch((err) => {
          let error_str = null;
          if (!err.response) {
            // This will handle network errors or cases where the server doesn't respond at all
            error_str = "Netzwerkfehler. Deine Internetverbindung ist entweder unterbrochen oder der Server ist nicht erreichbar.";
          }
          else if (err.response.status === 500) {
            error_str = "Interner Serverfehler. Bitte mache einen Screenshot von der Seite und schicke ihn an die Entwickler (oder Jonathan).";
          }
          else {
            error_str = err.response.data.detail.toString();
          }
          setErrorMessage(error_str);
          alert(error_str);
        });
    } else if (selectedCheckbox === "checkboxOffline") {
      setErrorMessage(null);

      const data = null;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      await axios
        .put(
          `${backendUrl}/OnlineOffline_Artikel/offline/${prodID}/`,
          data,
          config
        )
        .then((res) => {
          setinfoMessage(res.data);
          // Handle successful response
          // alert("status: " + res.status + " data: " + res.data);
        })
        .catch((err) => {
          let error_str = null;
          if (!err.response) {
            // This will handle network errors or cases where the server doesn't respond at all
            error_str = "Netzwerkfehler. Deine Internetverbindung ist entweder unterbrochen oder der Server ist nicht erreichbar.";
          }
          else if (err.response.status === 500) {
            error_str = "Interner Serverfehler. Bitte mache einen Screenshot von der Seite und schicke ihn an die Entwickler (oder Jonathan).";
          }
          else {
            error_str = err.response.data.detail.toString();
          }
          setErrorMessage(error_str);
          alert(error_str);
        });
    } else {
      const err =
        "Bitte wähle aus, ob das Item online oder offline gestellt werden soll";
      setErrorMessage(err);
      alert(err);
    }
  }

  const renderDefaultOptions = () => {
    return (
      <div className="OnOffArticlePage">
        <div style={{ position: "relative" }}>
          <h3>Stelle mit diesem Programm ein Item On- oder Offline!</h3>
          <form>
            <div>
              <label>
                <CustomTextField
                  type="text"
                  inputMode="integer"
                  label="Artikel ID"
                  placeholder="Artikel ID"
                  is_required={true}
                  errorText="Dieses Feld muss ausgefüllt sein"
                  value={prodID}
                  onChange={handleItemIDChange}
                />
              </label>
            </div>
          </form>
        </div>
        <FormGroup row className="item-on-off-checkbox-container">
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckbox === "checkboxOnline"}
                onChange={handleCheckboxChange}
                name="checkboxOnline"
                value="checkboxOnline"
                inputProps={{
                  // "data-hx-get": "/api/toggleCheckbox1",
                  // "data-hx-trigger": "change",
                }}
                className="itemOnOffCheckbox"
                sx={{
                  '&.Mui-checked': {
                    color: 'var(--naturGreen)', // Set color when checkbox is checked
                  },
                  '&:hover': {
                    borderColor: 'var(--naturGreen)', // Set border color on hover
                  }
                }}
              />
            }
            label="Online"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedCheckbox === "checkboxOffline"}
                onChange={handleCheckboxChange}
                name="checkboxOffline"
                value="checkboxOffline"
                inputProps={{
                  // "data-hx-get": "/api/toggleCheckbox2",
                  // "data-hx-trigger": "change",
                }}
                className="itemOnOffCheckbox"
                sx={{
                  '&.Mui-checked': {
                    color: 'var(--naturGreen)', // Set color when checkbox is checked
                  },
                  '&:hover': {
                    borderColor: 'var(--naturGreen)', // Set border color on hover
                  }
                }}
              />
            }
            label="Offline"
          />
        </FormGroup>
      </div>
    );
  };

  const handleOnlineSelectionChange =
    (field: string) => (e: SelectChangeEvent<string | number>) => {
      const value = e.target.value;
      if (field === "Lieferzeit") {
        setSelectedLieferzeit(value as string);
      } else if (field === "Markierung_2") {
        setSelectedMarkierung2(value as string);
      } else if (field === "Lager") {
        setSelectedLager(value as string);
      }
    };

  const renderOnlineOptions = () => {
    type Visibility = "visible" | "hidden";
    let vis: Visibility;

    if (selectedCheckbox === "checkboxOnline") {
      vis = "visible";
    } else {
      vis = "hidden";
    }

    let Lieferzeit_items = [
      { value: 1, label: "1" },
      { value: 2, label: "2" },
      { value: 3, label: "3" },
      { value: 4, label: "4" },
      { value: 5, label: "5" },
      { value: 6, label: "6" },
      { value: 7, label: "7" },
      { value: 8, label: "8" },
      { value: 9, label: "9" },
      { value: 10, label: "10" },
    ];

    let Markierung_2_items = [
      { value: 8, label: "8" },
      { value: 9, label: "9" },
      { value: 10, label: "10" },
      { value: 11, label: "11" },
    ];

    let Lager_items = [
      { value: "Kommissionslager Bestellartikel", label: "Kommissionslager" },
      { value: "Dropshipping", label: "Dropshipping" },
    ];

    return (
      <div style={{visibility: vis}}>
        <div className="wrapper">
          <div className="container">
            <CustomSelect
              label={"Lieferzeit"}
              id={"Lieferzeit"}
              items={Lieferzeit_items}
              inputLabel={"Lieferzeit"}
              is_required={true}
              value={selectedLieferzeit}
              onChange={handleOnlineSelectionChange("Lieferzeit")}
            />
            <br/>
            <img
              src="/availPic.png"
              alt="Verschiedene Lieferzeit Optionen"
              style={{width: "100%"}}
            />
          </div>

          <div className="container">
            <CustomSelect
              label={"Markierung_2"}
              id={"Markierung_2"}
              items={Markierung_2_items}
              inputLabel={"Markierung 2"}
              is_required={true}
              value={selectedMarkierung2}
              onChange={handleOnlineSelectionChange("Markierung_2")}
            />
            <br/>
            <img src="./flag2Pic.png" alt="Legende für Markierung 2"/>
          </div>

          <div className="container">
            <CustomSelect
              label={"Lager"}
              id={"Lager"}
              items={Lager_items}
              inputLabel={"Lager"}
              is_required={true}
              value={selectedLager}
              onChange={handleOnlineSelectionChange("Lager")}
            />
          </div>
        </div>
        <div className="container">
          <SearchableMultiSelect items={markets} inputLabel="Märkte" selectAllOption={true} selectAllInitially={true}
                                 value={selectedMarkets} setValue={setSelectedMarkets} />
        </div>
      </div>
    );
  };

  const renderErrorMessage = () => {
    if (errorMessage) {
      return (
        <div className="error-message-container">
          {" "}
          <p>{errorMessage}</p>{" "}
        </div>
      );
    } else {
      return null;
    }
  };

  const renderInfoMessage = () => {
    if (infoMessage) {
      return (
        <div className="info-message-container">
          {" "}
          <p>{infoMessage}</p>{" "}
        </div>
      );
    } else {
      return null;
    }
  };

  const renderGoButton = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "25px",
          alignItems: "center",
        }}
      >
        <SubmitButton
          label={
            "Item " +
            (selectedCheckbox === "checkboxOnline" ? "online" : "offline") +
            " stellen"
          }
          onClick={handleGoButton}
          size="small"
          type="submit"
        />
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>{"OnOff Artikel"}</title>
      </Helmet>
      {renderDefaultOptions()}
      {renderOnlineOptions()}
      {renderGoButton()}
      {renderErrorMessage()}
      {renderInfoMessage()}
      {ColorModeIcon()}
    </>
  );
}

export default OnOffArticle;
